module.exports = __webpack_public_path__ + "67a2f5cfde48944f2cce3620a8b6525c.MP3";